import { render, staticRenderFns } from "./NewSchool.vue?vue&type=template&id=249fdf68"
import script from "./NewSchool.vue?vue&type=script&lang=js"
export * from "./NewSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports